var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Dropdown, Textarea, Option, Button, Link, Spinner, } from '@fluentui/react-components';
import { JustificationContext } from '../definitions/Types';
import { Localization } from '../translations/LocalizationHelper';
import env from '../env';
import SuccessView from './SuccessView';
import ErrorView from './ErrorView';
import HttpClient from '../shared/HttpClient';
import { deserializeToken } from '../shared/Deserializers';
var isExpired = function (date) {
    var expirationDays = env.OVERRIDE_EXPIRATION_DAYS ? parseInt(env.OVERRIDE_EXPIRATION_DAYS, 10) || 7 : 7;
    var expTimestamp = Date.now() - expirationDays * 24 * 60 * 60 * 1000;
    return date.getTime() < expTimestamp;
};
var pad = function (n) { return String(n).padStart(2, '0'); };
var toIsoDate = function (date) {
    return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()));
};
var App = function () {
    var _a;
    var maxChars = 300;
    var queryParams = new URLSearchParams(window.location.search);
    var _b = useState(''), justification = _b[0], setJustification = _b[1];
    var _c = useState(JustificationContext.None), justificationContextPicker = _c[0], setPickerValue = _c[1];
    var _d = useState(Localization.getTranslations(null)), translation = _d[0], setTranslation = _d[1];
    var _e = useState(), pendingOverride = _e[0], setPendingOverride = _e[1];
    var _f = useState(false), success = _f[0], setSuccess = _f[1];
    var _g = useState(null), error = _g[0], setError = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var options = (_a = {},
        _a[JustificationContext.None] = translation.justificationForm.justificationReasonType.none,
        _a[JustificationContext.OverrideOneTimeException] = translation.justificationForm.justificationReasonType.overrideOneTimeException,
        _a[JustificationContext.OverrideNotSensitive] = translation.justificationForm.justificationReasonType.overrideNotSensitive,
        _a[JustificationContext.OverrideAuthorized] = translation.justificationForm.justificationReasonType.overrideAuthorized,
        _a);
    useEffect(function () {
        initializeTranslation();
    }, []);
    useEffect(function () {
        document.title = translation.title;
        initializeOverride();
    }, [translation]);
    var initializeTranslation = function () {
        var culture = queryParams.get("culture");
        setTranslation(Localization.getTranslations(culture));
    };
    var initializeOverride = function () {
        var overrideToken = queryParams.get("override");
        var override = deserializeToken(overrideToken);
        if (!override) {
            setError({
                title: translation.errorView.overrideLinkNotValid,
                description: translation.errorView.overrideLinkNotValidDescription,
            });
            return;
        }
        if (isExpired(override.Timestamp)) {
            setError({
                title: translation.errorView.overrideLinkExpired,
                description: translation.errorView.overrideLinkExpiredDescription,
            });
            return;
        }
        setPendingOverride(override);
    };
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var overrideInstance;
        return __generator(this, function (_a) {
            event.preventDefault();
            if (justificationContextPicker === JustificationContext.None || !pendingOverride) {
                return [2 /*return*/];
            }
            overrideInstance = {
                customerId: pendingOverride.CustomerId,
                pendingOverrideId: pendingOverride.Id,
                justification: "".concat(pendingOverride.UserMail, " (").concat(toIsoDate(new Date()), "): ").concat(justification),
                justificationContext: justificationContextPicker,
            };
            setLoading(true);
            setError(null);
            HttpClient.submitOverride(overrideInstance).then(function () {
                setSuccess(true);
            }).catch(function () {
                setError({
                    title: translation.errorView.submissionFailed,
                    description: translation.errorView.submissionFailedDescription,
                    button: translation.errorView.tryAgain,
                    onButtonClick: handleTryAgain
                });
            }).finally(function () {
                setLoading(false);
            });
            return [2 /*return*/];
        });
    }); };
    var handleTryAgain = function () {
        setSuccess(false);
        setError(null);
        setJustification('');
        setPickerValue(JustificationContext.None);
    };
    var handleTextareaChange = function (event) {
        setJustification(event.target.value);
    };
    var handlePickerChange = function (ev, data) {
        var pickerVal = data.optionValue;
        if (!pickerVal)
            return;
        var value = parseInt(pickerVal);
        setPickerValue(value);
        if (value === JustificationContext.None)
            setJustification('');
    };
    if (success) {
        return (_jsx(SuccessView, { translation: translation, pendingOverride: pendingOverride, justification: justification, justificationContextPicker: options[justificationContextPicker] }));
    }
    if (error) {
        return _jsx(ErrorView, __assign({}, error));
    }
    return (_jsxs("div", __assign({ className: "max-w-2xl mx-auto mt-10 p-6 bg-white rounded-sm" }, { children: [_jsx("h3", __assign({ className: "text-2xl font-bold mb-4" }, { children: translation.justificationForm.provideReasonTitle })), _jsx("p", __assign({ className: "mb-4" }, { children: translation.justificationForm.provideReasonDescription })), _jsxs("p", __assign({ className: "mb-2" }, { children: [_jsxs("strong", { children: [translation.justificationForm.file, ":"] }), _jsx("br", {}), (pendingOverride === null || pendingOverride === void 0 ? void 0 : pendingOverride.ObjectUrl) ? (_jsx(Link, __assign({ className: "link", href: pendingOverride === null || pendingOverride === void 0 ? void 0 : pendingOverride.ObjectUrl, target: '_blank' }, { children: pendingOverride === null || pendingOverride === void 0 ? void 0 : pendingOverride.ObjectName }))) : (pendingOverride === null || pendingOverride === void 0 ? void 0 : pendingOverride.ObjectName)] })), _jsxs("p", __assign({ className: "mb-4" }, { children: [_jsxs("strong", { children: [translation.justificationForm.recipients, ":"] }), _jsx("br", {}), pendingOverride === null || pendingOverride === void 0 ? void 0 : pendingOverride.SharingTargets.join(", ")] })), _jsxs("p", __assign({ className: "mb-4" }, { children: [translation.justificationForm.seeMoreInfo, _jsx(Link, __assign({ className: "link", href: "https://go.safetica.com/outlook", target: '_blank' }, { children: translation.justificationForm.thisArticle })), "."] })), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", __assign({ className: "mb-5" }, { children: [_jsx("label", __assign({ className: "block text-sm font-medium text-primary mb-1" }, { children: translation.justificationForm.reasonForOverride })), _jsx(Dropdown, __assign({ className: "mt-1 w-full", onOptionSelect: handlePickerChange, value: options[justificationContextPicker], selectedOptions: [justificationContextPicker.toString()] }, { children: Object.entries(options).map(function (_a) {
                                    var key = _a[0], text = _a[1];
                                    return (_jsx(Option, __assign({ value: key }, { children: text }), key));
                                }) }))] })), _jsxs("div", __assign({ className: "mb-5" }, { children: [_jsx("label", __assign({ className: "block text-sm font-medium text-primary mb-1" }, { children: translation.justificationForm.additionalDescription })), _jsx(Textarea, { className: "justification-textarea", value: justification, onChange: handleTextareaChange, maxLength: maxChars, disabled: loading || justificationContextPicker === JustificationContext.None }), justificationContextPicker !== JustificationContext.None && (_jsxs("div", __assign({ className: "mt-1 text-sm text-st-color-text-secondary" }, { children: [justification.length, "/", maxChars] })))] })), _jsx("div", __assign({ className: "flex justify-center" }, { children: _jsx(Button, __assign({ type: "submit", disabled: loading || justificationContextPicker === JustificationContext.None, className: "text-white primary-button w-1/3" }, { children: translation.justificationForm.submit })) }))] })), loading && (_jsx("div", __assign({ className: "fixed inset-0 flex items-center justify-center bg-white opacity-80 z-50" }, { children: _jsx(Spinner, { className: "spinner", size: "large" }) })))] })));
};
export default App;
